import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import styles from './index.scss';

export const NSAlertDetailPartyIdentity = ({
  GS,
  data,
  alertPartyIdentity = {}
}) => {
  const getAlertViewPartyIdentity = (GS) => {
    let renderData = null;
    if (GS) {
      const sortedSettings = orderBy(
        GS.widgetConfig,
        ['columnIndex'],
        ['asc']
      ).filter((column) => column.columnVisibility);
      renderData = sortedSettings.map((setting, id) => {
        return (
          <div className={styles.list} key={id}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => {
                return (
                  <div key={idx} className={styles.list_item}>
                    <div className={styles.list_key}>
                      {column.itemLabel + ':'}{' '}
                    </div>
                    <div className={styles.list_value}>
                      {column.itemName === 'isWhitelisted'
                        ? data[column.itemName] ||
                          alertPartyIdentity?.[column.itemName]
                          ? 'Yes'
                          : 'No'
                        : data[column.itemName] ||
                          alertPartyIdentity?.[column.itemName]
                        ? data[column.itemName] ||
                          alertPartyIdentity?.[column.itemName]
                        : '--'}
                    </div>
                  </div>
                );
              })}
            <div className={styles.horizontalLine}></div>
          </div>
        );
      });
    }

    return renderData;
  };

  if (GS?.isVisible && Object.keys(data)?.length)
    return (
      <React.Fragment>
        <div className={styles.partyIdentity}>
          {getAlertViewPartyIdentity(GS)}
        </div>
      </React.Fragment>
    );
  else return null;
};

NSAlertDetailPartyIdentity.propTypes = {
  GS: PropTypes.object,
  data: PropTypes.object
};

export default NSAlertDetailPartyIdentity;
